import React, { createContext, useState, useEffect, useContext } from 'react';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [modules, setModules] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Load state from localStorage on initialization
    const storedUser = localStorage.getItem('user');
    const storedModules = localStorage.getItem('modulesDetails');
    const token = localStorage.getItem('token');

    if (token && storedUser && storedModules) {
      setUser(JSON.parse(storedUser));
      setModules(JSON.parse(storedModules));
    }
    setLoading(false);
  }, []);

  const login = (userData, modulesData, token) => {
    setUser(userData);
    setModules(modulesData);
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(userData));
    localStorage.setItem('modulesDetails', JSON.stringify(modulesData));
  };

  const logout = () => {
    setUser(null);
    setModules([]);
    localStorage.clear();
    window.location.href = '/';
  };

  return (
    <AuthContext.Provider value={{ user, modules, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
